import { motion } from 'framer-motion';

const Servicios = () => {

  // 🔮 TIPOS DE MAGIA
  const magias = [
    { 
      nombre: "Magia Blanca", 
      descripcion: "Trabajos de luz, protección, sanación y equilibrio espiritual." 
    },
    { 
      nombre: "Magia Negra", 
      descripcion: "Rituales poderosos, control energético y dominio de situaciones." 
    },
    { 
      nombre: "Magia Roja", 
      descripcion: "Energía pasional, unión de parejas, deseo y amor intenso." 
    },
  ];

  // 🔥 SERVICIOS
  const services = [
    { img: '/images/amarre.png', title: 'Amarres de Amor', desc: 'Rituales poderosos para unir almas destinadas y fortalecer lazos eternos.' },
    { img: '/images/separacion.png', title: 'Separaciones', desc: 'Guía personalizada para resolver dudas y conectar con tu guía interior.' },
    { img: '/images/union.png', title: 'Unión de Parejas', desc: 'Cartas que revelan el futuro y aclaran el presente con precisión mística.' },
    { img: '/images/limpieza.png', title: 'Endulces y Limpiezas', desc: 'Endulzar situaciones difíciles y purificar tu aura de malas energías.' },
    { img: '/images/alejamiento.png', title: 'Alejamientos', desc: 'Expulsar malas influencias y cortar energías negativas.' },
    { img: '/images/endulzamiento.png', title: 'Endulzamiento', desc: 'Atraer dulzura, calma y armonía a tu relación.' }
  ];

  return (
    <div className="pt-24 pb-12 bg-[#1E0B1A] text-yellow-300">
      <div className="container mx-auto px-6">

        {/* 🔮 TITULO PRINCIPAL */}
        <motion.section 
          className="text-center py-10"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-yellow-400 to-red-400 bg-clip-text text-transparent">
            Contamos con 3 tipos de magia
          </h2>
        </motion.section>

        {/* ✨ TARJETAS DE MAGIA (nuevo estilo solicitado) */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
  
  {/* Tarjeta Blanca */}
  <motion.div
    className="bg-white/20 backdrop-blur-md border border-white/40 p-6 rounded-2xl text-center shadow-lg"
    whileHover={{
      scale: 1.05,
      boxShadow: "0 0 20px rgba(255, 255, 255, 0.7)",
      borderColor: "#ffffff"
    }}
  >
    <h3 className="text-xl font-bold text-white">Magia Blanca</h3>
  </motion.div>

  {/* Tarjeta Negra */}
  <motion.div
    className="bg-black/40 backdrop-blur-md border border-black/ p-6 rounded-2xl text-center shadow-lg"
    whileHover={{
      scale: 1.05,
      boxShadow: "0 0 20px rgba(92, 92, 92, 0.6)",
      borderColor: "#555555ff"
    }}
  >
   <h3 className="text-xl font-bold text-gray-300 drop-shadow-md">Magia Negra</h3>
  </motion.div>

  {/* Tarjeta Roja */}
  <motion.div
    className="bg-red-600/30 backdrop-blur-md border border-red-400 p-6 rounded-2xl text-center shadow-lg"
    whileHover={{
      scale: 1.05,
      boxShadow: "0 0 20px rgba(255, 0, 0, 0.6)",
      borderColor: "#ff0000"
    }}
  >
    <h3 className="text-xl font-bold text-red-300">Magia Roja</h3>
  </motion.div>

</div>


        {/* 🔥 TITULO SECUNDARIO */}
        <motion.h3 
          className="text-3xl font-bold text-center mb-16 mt-20 text-yellow-300"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          Limpiezas y trabajos a distancia ¡Todo garantizado!
        </motion.h3>

        {/* 🧿 SERVICIOS */}
        <motion.div 
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, staggerChildren: 0.1 }}
        >
          {services.map((service, index) => (
            <motion.div 
              key={index}
              className="bg-black/20 backdrop-blur-md rounded-2xl p-6 text-center border border-yellow-300/30"
              whileTap={{ scale: 0.98 }}
              transition={{ duration: 0.4, type: 'spring' }}
            >
              {/* 🔮 IMAGEN */}
              <motion.div className="relative flex justify-center mb-4">
                <motion.img
                  src={service.img}
                  alt={service.title}
                  className="w-40 h-40 object-contain rounded-full border border-yellow-300 shadow-[0_0_20px_rgba(255,255,0,0.2)]"
                  whileHover={{ scale: 1.15, rotate: 6 }}
                  transition={{ duration: 0.4 }}
                />
                <motion.div
                  className="absolute inset-0 rounded-full blur-2xl bg-yellow-500/20"
                  animate={{ opacity: [0.3, 0.8, 0.3], scale: [1, 1.1, 1] }}
                  transition={{ duration: 3, repeat: Infinity }}
                />
              </motion.div>

              {/* TITULO */}
              <h3 className="text-2xl font-bold mb-4 text-yellow-300">
                {service.title}
              </h3>

              {/* DESCRIPCIÓN */}
              <p className="text-yellow-300/80 leading-relaxed">
                {service.desc}
              </p>

              {/* BOTÓN */}
              <motion.button 
                className="mt-6 bg-gradient-to-r from-[#163B6B] to-[#2F3B4C] text-[#EDEDED] px-6 py-2 rounded-full font-semibold"
                whileHover={{ 
                  scale: 1.05,
                  backgroundColor: '#b91c1c',
                  boxShadow: '0 10px 20px rgba(239, 68, 68, 0.5)'
                }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.3 }}
              >
                Reservar Ahora
              </motion.button>

            </motion.div>
          ))}
        </motion.div>

      </div>
    </div>
  );
};

export default Servicios;
